$('.expertise-image-slider').slick({
    infinite: true,
    speed: 500,
    fade: true,
    arrows: false,
    cssEase: 'linear',
    asNavFor: '.expertise-text-slider',
});
function innitSlider(){
    $('.expertise-text-slider').slick({
        infinite: true,
        speed: 0,
        fade: true,
        arrows: true,
        prevArrow: '.expertise-slider-nav.prev',
        nextArrow: '.expertise-slider-nav.next',
        cssEase: 'linear',
        adaptiveHeight: true,
        asNavFor: '.expertise-image-slider',
    });
}
innitSlider()
$('.expertise-text-slider-item-button').on('click', function (){
    $(this).toggleClass('active')
    $(this).parent('.expertise-text-slider-item').find('.expertise-text-slider-item-content').toggleClass('active')
    let activeSlideIndex = $('.expertise-text-slider').slick('slickCurrentSlide');
    $('.expertise-text-slider').slick('unslick');
    innitSlider()
    $('.expertise-text-slider').slick('slickGoTo', activeSlideIndex);
})
